// extracted by mini-css-extract-plugin
export default {"ChatLoaderWrapper":"ChatLoader_ChatLoaderWrapper__BVNPo","ChatLoader":"ChatLoader_ChatLoader__COB1y","LoaderDots":"ChatLoader_LoaderDots__rXB+w"};